module.exports = __webpack_public_path__ + "assets/ScrollDownIcon.0443d3c1640c6343b5276e9f22f1f601.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/buttons/ScrollDownIcon.svg
// module id = 860
// module chunks = 0